import React from 'react';
import {view} from '@sail/ui';

interface Props {
  children: React.ReactNode;
  type?: 'default' | 'positive';
}

const BADGE_STYLES = {
  default: {
    color: 'subdued',
    backgroundColor: 'offset',
  },
  positive: {
    color: '#006635',
    backgroundColor: '#30B1300F',
  },
} as const;

export const Badge = ({children, type = 'default'}: Props) => {
  return (
    <view.div
      css={{
        stack: 'x',
        alignY: 'center',
        paddingX: 'small',
        paddingY: 'xsmall',
        borderRadius: 'medium',
        ...BADGE_STYLES[type],
        width: 'fit',
      }}
    >
      {children}
    </view.div>
  );
};
